<template>
  <div class="order-info">
    <admin-title title="全域订单明细" />

    <card class="order-list">
      <tp-table
        :table-data="qyOrderList"
        :columns="columns"
        :is-page="false"
      />
    </card>
  </div>
</template>

<script>
const columns = [
  {
    label: "平台名称",
    prop: "appName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{ row["appName"] }</p>
    }
  },
  {
    label: "订单号",
    prop: "appOrderNo",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div style="display: flex; gap: 5px;">
          <span>{ row["appOrderNo"] }</span>
          <el-tag type="warning" size="small">{ row["orderStatusName"] }</el-tag>
        </div>
      )
    }
  },
  {
    label: "订单类型",
    prop: "orderTypeName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{ row["orderTypeName"] }</p>
    }
  },
  {
    label: "系统/最终评级",
    prop: "hitGrade",
    minWidth: "120",
    customRender(h, row) {
      return <p>{ row["sysHitGrade"] || "-" } / { row["finalHitGrade"] || "-" }</p>
    }
  },
  {
    label: "下单时间",
    prop: "orderCreateTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{ row["orderCreateTime"] }</p>
    }
  },
  {
    label: "已收租金/总租金",
    prop: "rentPrice",
    minWidth: "150",
    customRender(h, row) {
      return <p>{ row["repayRentPrice"] } / { row["totalRentPrice"] }</p>
    }
  },
  {
    label: "租金回收率",
    prop: "repayRentRate",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["repayRentRate"] }</p>
    }
  },
  {
    label: "设备状态",
    prop: "deviceStatusName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["deviceStatusName"] || "-" }</p>
    }
  },
];

export default {
  name: "QyOrderList",

  props: {
    qyOrderList: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      columns,
    };
  },
};
</script>

<style lang="scss" scoped>
.order-info /deep/ {
  width: 100%;
  border: 1px solid #c5c5c5;
  border-radius: 15px;
  padding: 15px 20px;

  .order-list {
    .blacklist {
      color: #ffffff;
      background-color: #000000;
      font-weight: bold;
    }
    .whitelist {
      color: #000000;
      background-color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
